export enum View {
  CONTRACT_DETAIL_PAGE = 'CONTRACT_DETAIL_PAGE',
  CONTACT_PAGE = 'CONTACT_PAGE',
  CLAIM_DETAIL_PAGE = 'CLAIM_DETAIL_PAGE',
  MOBILE_CONTACT_ENGINE = 'MOBILE_CONTACT_ENGINE',
  CONTRACT_ENGINE = 'CONTRACT_ENGINE',
  ACCOUNT_PAGE = 'ACCOUNT_PAGE',
  CLAIM_ENGINE = 'CLAIM_ENGINE',
  ACCOUNT_ENGINE = 'ACCOUNT_ENGINE',
  DESKTOP_ACCOUNT_ENGINE = 'DESKTOP_ACCOUNT_ENGINE',
  MOBILE_RESCIND_CONTRACT = 'MOBILE_RESCIND_CONTRACT',
  HOME = 'HOME',
  CONTRACTS = 'CONTRACTS',
  CLAIMS = 'CLAIMS',
  DESKTOP_RESCIND_CONTRACT = 'DESKTOP_RESCIND_CONTRACT',
}
